import React, { useEffect, useState, useMemo } from 'react'
// import WorkflowPhasesPage from '../../../../Operations/Scenes/Workflows/Components/WorkflowPhasesPage'
import WorkflowPhasesPage from '../../../Operations/Scenes/Workflows/Components/WorkflowPhasesPage';
import GetWorkflowMainCategoryService from '../../../../../../Service/OPSServices/WorkflowsService/GetWorkflowMainCategoryService';
import { connect } from 'react-redux';

import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import { useLocation } from "react-router-dom";




export const ProactiveWorkflowsDropDownOption = (props) => {

  const [selectedItem, setSelectedItem] = useState(null)

  return (
    <div className={props.class}>

      <UncontrolledButtonDropdown>

        {/* ===== DROPDOWN LABEL ===== */}
        <DropdownToggle caret color="link">
          {selectedItem !== null && props.buttons &&props.buttons[selectedItem]
            ? props.buttons[selectedItem].name
            : "Workflows"}
        </DropdownToggle>


        {/* ===== DROPDOWN LIST ===== */}
        <DropdownMenu className="dropdown-menu-right">

          {(props.buttons || []).map((item, index) => (
            <DropdownItem
              key={item.id}
              active={selectedItem === index}
              onClick={() => {

                // set local UI selection
                setSelectedItem(index)

                // send selected workflow to parent
                props.handleWorkflowChange && props.handleWorkflowChange(item)
              }}
            >
              {item.name}
            </DropdownItem>
          ))}

        </DropdownMenu>

      </UncontrolledButtonDropdown>

    </div>
  )
}

function ProjectsDashWorkFlowsMainPage(props) {
    const [workflowPhasesList,setWorkflowPhasesList]=useState()
    const [workflowMainCategory, setWorkflowMainCategory] = useState("");

    // const [selectedStoreData, setSelectedStoreData] = useState({
    //     integerId: "",
    //     storeName: "",
    //   });
      const selectedStoreData = useMemo(() => {
        return {
          integerId: props.selectedProjectData &&props.selectedProjectData.integerId || '',
          storeName: props.selectedProjectData &&props.selectedProjectData.storeName || ''
        };
      }, [props.selectedProjectData]);
    useEffect(()=>{
        console.log(props.selectedProjectData);
        // setSelectedStoreData({integerId:props.selectedProjectData.integerId,
        //     storeName:props.selectedProjectData.storeName
        //     }
        // )
        GetWorkflowMainCategoryService(props.token).then((res)=>{
            console.log(res);
            setWorkflowMainCategory(res.masterWorkflows);
            // const filteredPhases = res.workflowPhases && res.workflowPhases.filter(phase => phase.WorkflowsMaster == props.selectedProjectData.workflowsId).sort((a, b) => a.id - b.id);
          
            let workflowIds = props.selectedProjectData.workflowsId

            // convert to array safely
            if (!Array.isArray(workflowIds)) {
                workflowIds = workflowIds ? [workflowIds] : []
            }

            const filteredPhases =
                res.workflowPhases &&res.workflowPhases
                    .filter(phase =>
                        workflowIds.includes(phase.WorkflowsMaster)
                    )
                    .sort((a, b) => a.id - b.id)

            // setWorkflowPhasesList(filteredPhases)
            setWorkflowPhasesList(filteredPhases)
            console.log(filteredPhases);

     
        })

    },[])
  return (

  <>
  <div className="ml-3">
    <WorkflowPhasesPage 
    flag={false}
    selectedWorkflowMasterId={props.selectedWorkflowMasterId}
    workflowPhases={workflowPhasesList}
    selectedProjectData={props.selectedProjectData}
    workflowMainCategory={workflowMainCategory}
    selectedStoreData={selectedStoreData}
    key={workflowPhasesList}
    hideBackButton={true}
    />
  </div>
  </>
  )
}
const mapStateToProps = state => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
    }
  }
  
  export default connect(mapStateToProps)(ProjectsDashWorkFlowsMainPage);
